import React, { useEffect, useState } from 'react';
import {
  Container,
  FormGroup,
  Grid,
  TextField,
  MenuItem,
  Switch,
  Card,
  CardContent,
} from '@mui/material';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {
  LocalizationProvider,
  DatePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import DialogMain from '../../components/Dialogs/dialogMain';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import deLocale from 'date-fns/locale/pt-BR';
import { parseISO, isValid, format } from 'date-fns';
import './style.css';
import FormControl from '@mui/material/FormControl';

function Occurrence(props) {
  const [selectedBeginDate, handleBeginDateChange] = useState(new Date());
  const [ponds, setPonds] = useState([]);
  const [locale, setLocale] = React.useState('pt');
  const classes = useStyles();
  const [checked, setChecked] = useState(false);
  const [property, setProperty] = useState(null);
  const [openDia, setOpenDia] = React.useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const disable = useSelector((state) => state.disable.disable);
  const [selectedExpirationDate, handleSelectedExpirationDate] = useState(
    new Date(),
  );
  const [selectedPaymentDate, handleSelectedPaymentDate] = useState(null);
  const error = Error();
  const success = Success();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const selectMethodValue = (value) => parseInt(value?.id);

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function load() {
      setOpenProgress(true);
      api.get('/ponds').then((resp) => {
        if (resp.data.length === 0) {
          setOpenDia(true);
        }
        setPonds(resp.data);
        setOpenProgress(false);
        if (id) {
          api.get(`/occurrences/${id}`).then((resp) => {
            formik.setValues({
              ...resp.data,
              /* affecteds: resp.data.affecteds.map((value) => {
                                return { pond_id: value.pond_id }
                            }), */
            });
            // setSelectedPonds(resp.data.affecteds)
            handleBeginDateChange(new Date(resp.data.first_observation));
          });
        } else {
          api.get('/properties').then((resp) => {
            if (resp.data) {
              setProperty(resp.data.id);
              formik.values.property_id = resp.data.id;
              setOpenProgress(false);
            }
          });
        }
      });
    }
    global.loading = false;
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/occurrences/${id}`, { ...data })
        : await api.post('/occurrences/', { ...data });
      success();
      history.push('/occurrences');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      property_id: property,
      first_observation: '',
      degree: 1,
      status: 'Novo',
      weight: 1,
      description: '',
      estimated_loss: '',
      conclusion: '',
      type: '',
      //            affecteds: [],
    },
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      values.first_observation = selectedBeginDate.toUTCString();
      /* values.affecteds = selectedPonds.map(function (pond) {
                return { pond_id: pond.pond_id ? pond.pond_id : pond.id }
            }) */
      request(values);
    },
  });

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.root}>
          <h2 className="title">Dados da Ocorrência</h2>
          <div>
            <FormGroup style={{ marginLeft: 0, marginRight: 0 }}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} lg={2}>
                      <FormControlLabel
                        control={(
                          <Switch
                            checked={checked}
                            color="primary"
                            size="small"
                            onChange={(event) => {
                              setChecked(event.target.checked);
                              formik.values.is_checked = event.target.checked;
                              if (!formik.values.is_checked) formik.values.initial_date = null;
                              if (!formik.values.is_checked) formik.values.final_date = null;
                            }}
                          />
                        )}
                        label="Incluir período?"
                        disabled={props.id}
                      />
                    </Grid>
                    {checked || (
                      <Grid item xs={12} sm={10}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale={locale}
                        >
                          <DatePicker
                            InputLabelProps={{
                              style: { pointerEvents: 'auto' },
                            }}
                            label="Data da Ocorrência"
                            name="initialDate"
                            variant="inline"
                            inputVariant="outlined"
                            invalidDateMessage="Data Inválida"
                            value={
                              isValid(parseISO(formik.values.initial_date))
                                ? parseISO(formik.values.initial_date)
                                : formik.values.initial_date
                            }
                            onChange={(date) => {
                              if (isValid(date)) handleSelectedExpirationDate(date);
                              if (isValid(date)) {
                                formik.setFieldValue(
                                  'initial_date',
                                  format(date, 'yyyy-MM-dd'),
                                );
                              }
                            }}
                            format="dd/MM/yyyy"
                            fullWidth
                            onBlur={formik.handleBlur}
                            error={
                              formik.values.is_checked
                                ? formik.touched.initial_date
                                  && formik.errors.initial_date
                                : ''
                            }
                            helperText={
                              formik.values.is_checked
                                ? formik.touched.initial_date
                                  && formik.errors.initial_date
                                : ''
                            }
                            // inputFormat="DD/MM/YYYY"
                            renderInput={(params) => <TextField {...params} fullWidth />}
                            // disabled={
                            //   props.id || props.disableAll
                            //     ? true
                            //     : false || !checked
                            // }
                          />
                        </LocalizationProvider>
                      </Grid>
                    )}
                    {checked && (
                      <Grid item xs={12} sm={5}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale={locale}
                        >
                          <DatePicker
                            InputLabelProps={{
                              style: { pointerEvents: 'auto' },
                            }}
                            label="Data Inicial"
                            name="initialDate"
                            variant="inline"
                            inputVariant="outlined"
                            invalidDateMessage="Data Inválida"
                            value={
                              isValid(parseISO(formik.values.initial_date))
                                ? parseISO(formik.values.initial_date)
                                : formik.values.initial_date
                            }
                            onChange={(date) => {
                              if (isValid(date)) handleSelectedExpirationDate(date);
                              if (isValid(date)) {
                                formik.setFieldValue(
                                  'initial_date',
                                  format(date, 'yyyy-MM-dd'),
                                );
                              }
                            }}
                            format="dd/MM/yyyy"
                            fullWidth
                            onBlur={formik.handleBlur}
                            error={
                              formik.values.is_checked
                                ? formik.touched.initial_date
                                  && formik.errors.initial_date
                                : ''
                            }
                            helperText={
                              formik.values.is_checked
                                ? formik.touched.initial_date
                                  && formik.errors.initial_date
                                : ''
                            }
                            disabled={
                              props.id || props.disableAll
                                ? true
                                : false || !checked
                            }
                            // inputFormat="DD/MM/YYYY"
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    )}
                    {checked && (
                      <Grid item xs={12} sm={5}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale={locale}
                        >
                          <DatePicker
                            InputLabelProps={{
                              style: { pointerEvents: 'auto' },
                            }}
                            label="Data Final"
                            name="finalDate"
                            variant="inline"
                            inputVariant="outlined"
                            invalidDateMessage="Data Inválida"
                            value={
                              isValid(parseISO(formik.values.final_date))
                                ? parseISO(formik.values.final_date)
                                : formik.values.final_date
                            }
                            onChange={(date) => {
                              handleSelectedPaymentDate(date);
                              if (isValid(date)) {
                                formik.setFieldValue(
                                  'final_date',
                                  format(date, 'yyyy-MM-dd'),
                                );
                              }
                            }}
                            format="dd/MM/yyyy"
                            fullWidth
                            onBlur={formik.handleBlur}
                            error={
                              formik.values.is_checked
                                ? formik.touched.final_date
                                  && formik.errors.final_date
                                : ''
                            }
                            helperText={
                              formik.values.is_checked
                                ? formik.touched.final_date
                                  && formik.errors.final_date
                                : ''
                            }
                            disabled={
                              props.id || props.disableAll
                                ? true
                                : false || !checked
                            }
                            // inputFormat="DD/MM/YYYY"
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            </FormGroup>
          </div>
          <Card>
            <CardContent>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      id="select-pay-method"
                      name="payMethod"
                      label="Tipo do problema"
                      variant="outlined"
                      fullWidth
                      select
                      // as="select"
                    >
                      <MenuItem value={10}>Crescimento</MenuItem>
                      <MenuItem value={20}>Mortalidade</MenuItem>
                      <MenuItem value={30}>Conversão Alimentar</MenuItem>
                      <MenuItem value={40}>Outro</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <RadioGroup
                      className="box"
                      row
                      aria-label="degree"
                      name="degree"
                      value={formik.values.degree}
                      onChange={formik.handleChange}
                    >
                      <FormLabel component="legend" className="labels">
                        Grau do Problema:
                      </FormLabel>

                      <FormControlLabel
                        value="baixo"
                        control={<Radio color="primary" />}
                        label="Baixo"
                        labelPlacement="top"
                        checked={
                          !!((formik.values.degree === 1)
                          | (formik.values.degree === 'baixo'))
                        }
                      />
                      <FormControlLabel
                        value="medio"
                        control={<Radio color="primary" />}
                        label="Médio"
                        labelPlacement="top"
                        checked={
                          !!((formik.values.degree === 2)
                          | (formik.values.degree === 'medio'))
                        }
                      />
                      <FormControlLabel
                        value="alto"
                        control={<Radio color="primary" />}
                        label="Alto"
                        labelPlacement="top"
                        checked={
                          !!((formik.values.degree === 3)
                          | (formik.values.degree === 'alto'))
                        }
                      />
                    </RadioGroup>
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <FormGroup>
                <TextField
                  type="text"
                  id="estimated_loss"
                  label="Custo estimado de perda (em R$)"
                  variant="outlined"
                  name="estimated_loss"
                  value={formik.values.estimated_loss}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <div className="espaco" />
              <FormGroup>
                <TextField
                  id="outlined-multiline-static"
                  label="Descrição do Problema"
                  multiline
                  rows={4}
                  variant="outlined"
                />
              </FormGroup>
            </CardContent>
          </Card>
        </div>
        <GroupButton
          deleteRoute="/occurrences/"
          routeDelete="/occurrences"
          returnRoute="/occurrences"
          id={id}
          disable={disable}
          message="A exclusão dessa ocorrência pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default Occurrence;
